export default "__VITE_ASSET__DMUG_3qz__"